import { render, staticRenderFns } from "./EditClinician.vue?vue&type=template&id=61fb65c9&"
import script from "./EditClinician.vue?vue&type=script&lang=js&"
export * from "./EditClinician.vue?vue&type=script&lang=js&"
import style0 from "./EditClinician.vue?vue&type=style&index=0&lang=css&"
import style1 from "./EditClinician.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports